import { ClientConfigResponse, EmulateBanner } from '@app-model/api';

import * as ConfigActions from './config.actions';

export interface State {
  clientConfig: ClientConfigResponse;
  dealerView: boolean;
  error: string;
  initialClientConfig: ClientConfigResponse;
  success: boolean;
}

const InitialState: State = {
  clientConfig: new ClientConfigResponse(),
  dealerView: true,
  error: '',
  initialClientConfig: new ClientConfigResponse(),
  success: false,
};

export function reducer(state = InitialState, action: ConfigActions.All): State {
  switch (action.type) {
    case ConfigActions.GET_INITIAL_LAYOUT: {
      return { ...state };
    }

    case ConfigActions.GET_INITIAL_LAYOUT_SUCCESS: {
      if (!action.payload.css.emulateBanner) {
        //if emulateBanner is not passed to UI, set default
        action.payload.css.emulateBanner = new EmulateBanner();
      }

      return {
        ...state,
        clientConfig: action.payload,
        initialClientConfig: action.payload,
        success: true,
        /// add more when you start calling the effects API for initial layout
      };
    }

    // will update configurations for testing purposes.. call reset layout when
    // navigating away from admin page
    case ConfigActions.TEST_LAYOUT: {
      return { ...state, clientConfig: action.payload };
    }

    case ConfigActions.RESET_LAYOUT: {
      return { ...state, clientConfig: state.initialClientConfig };
    }

    case ConfigActions.TOGGLE_DEALER_VIEW: {
      return { ...state, dealerView: action.payload };
    }

    case ConfigActions.CONFIG_FAILURE: {
      return { ...state, success: false, error: action.payload };
    }

    default: {
      return state;
    }
  }
}
